import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ChangeLogo from "../../../assets/svg/Change password.svg";
import axios from "../../../components/Hooks/axios";
import { addAccount } from "../../../redux/slices/accountSlice";
import { logOut, setAuth, setUserObject } from "../../../redux/slices/authSlice";
import LoadingBg from "../Loading Bg/LoadingBg";
import classes from "./Verification.module.css";

const Verification = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const { tempEmail } = useSelector((state) => state.temp);

	const targetEmail = tempEmail || location.state?.email || "";

	const [otp, setOtp] = useState(new Array(4).fill(""));
	const [activeOtp, setActiveOtp] = useState(0);
	const [disableBtn, setDisableBtn] = useState(false);
	const [sendOTPBtn, setSendOTPBtn] = useState(true);
	const [countDown, setCountDown] = useState(12);
	const inputRef = useRef();

	useEffect(() => {
		if (!targetEmail) {
			navigate(location.state?.signUp ? "/signup" : "/signin", { replace: true });
		}
	}, [targetEmail, location.state?.signUp, navigate]);

	useEffect(() => {
		inputRef.current?.focus();
	}, [activeOtp]);

	useEffect(() => {
		setSendOTPBtn(true);
		const timer = setInterval(function () {
			if (countDown > 0) {
				setCountDown(countDown - 1);
			}
		}, 1000);
		if (countDown === 0) setSendOTPBtn(false);
		return () => clearInterval(timer);
	}, [sendOTPBtn, countDown]);

	const handelOnChange = (e, index) => {
		const value = e.target.value;
		const newOtp = [...otp];
		newOtp[index] = value.substring(value.length - 1);
		setActiveOtp(index + 1);
		setOtp(newOtp);
	};

	const handelSubmit = () => {
		if (otp[0] === "" || otp[1] === "" || otp[2] === "" || otp[3] === "") {
			inputRef.current?.focus();
			return toast.warn("Please fill !!");
		}
		setDisableBtn(true);
		axios
			.post("/auth/verify-otp", {
				email: targetEmail,
				otp: otp.join(""),
				isSignUp: Boolean(location.state?.signUp),
			})
			.then(({ data }) => {
				setDisableBtn(false);
				toast.success(data.message);
				if (data.success) {
					if (location.state?.signUp) {
						dispatch(
							setAuth({
								userId: data.data._id,
								token: data.token,
								rememberMe: location.state?.rememberMe,
							})
						);
						dispatch(setUserObject(data.data));
						dispatch(addAccount({ userId: data.data._id, user: data.data, token: data.token }));
						axios.defaults.headers.Authorization = data.token;
						navigate("/interest", { replace: true });
					} else {
						navigate("/change-password", {
							state: {
								token: data.token,
								pageLocation: location.state?.pageLocation,
								userId: location.state?.userId,
							},
						});
					}
				}
			})
			.catch(({ response }) => {
				setDisableBtn(false);
				const errorMsg = response?.data?.message || response?.data?.error || "OTP is not correct.";
				toast.error(errorMsg);
				if (location.state?.signUp) {
					// User not verified with correct OTP during Sign Up:
					// Clear any credentials and redirect to Sign Up page again
					dispatch(logOut());
					navigate("/signup", { replace: true });
				}
			});
	};

	const handelSendOTP = () => {
		setSendOTPBtn(true);
		const id = toast.loading("Please wait...");
		axios
			.post("/auth/otp", {
				email: targetEmail,
			})
			.then(({ data }) => {
				setCountDown(12);
				toast.update(id, {
					render: data.message,
					type: "success",
					isLoading: false,
					autoClose: 3000,
				});
				toast.info(data.otp, {
					autoClose: 12000,
				});
				setOtp(["", "", "", ""]);
				setActiveOtp(0);
				inputRef.current?.focus();
			})
			.catch(({ response }) => {
				toast.error(response?.data?.error || response?.data?.message || "Failed to send OTP.");
			});
	};

	return (
		<div className={classes["main-container"]}>
			<LoadingBg />
			<div className={classes["sub-container"]}>
				<div className={classes.header}>
					<div className={classes["text-container"]}>
						<p className={classes.heading}>Verification Code</p>
						<p className={classes.text}>
							{/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. Purus est tortor gravida nibh id at. */}
						</p>
					</div>
					<div className={classes.image}>
						<img src={ChangeLogo} alt="" />
					</div>
				</div>
				<div className={classes.form}>
					<div className={classes.input}>
						{otp.map((_, index) => (
							<input
								ref={index === activeOtp ? inputRef : null}
								key={index}
								type="number"
								className={classes["input-box"]}
								value={otp[index]}
								onChange={(e) => handelOnChange(e, index)}
							/>
						))}
					</div>
					<div className={classes.actions}>
						<button type="submit" className={classes.btn} onClick={handelSubmit} disabled={disableBtn}>
							Verify
						</button>
					</div>
					<div className={classes.footer}>
						<p
							className={classes.link}
							onClick={() => {
								if (location.state?.signUp) {
									if (targetEmail) {
										axios.post("/auth/cancel-signup", { email: targetEmail }).catch(() => {});
									}
									dispatch(logOut());
									navigate("/signup", { replace: true });
								} else {
									navigate("/signin");
								}
							}}
						>
							{location.state?.signUp ? "Back to Sign Up" : "Back to Sign In"}
						</p>
						<section className={classes.time}>
							<button className={classes.text2} onClick={handelSendOTP} disabled={sendOTPBtn}>
								Resend Code In:
							</button>
							<p className={classes.timer}>{countDown}s</p>
						</section>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Verification;


